import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { environment } from '../../../environments/environment';
import { FormsTemplateService } from '../../services/forms-template.service';
import { ComponentService } from '../../services/component.service';
import { Apiservice } from '../../services/api.service';
import ODataStore from 'devextreme/data/odata/store';

export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  UP_ARROW = 38,
  DOWN_ARROW = 40,
  BACKSPACE_KEY = 8
}

function isNotEmpty(value: any): boolean {
  return value !== undefined && value !== null && value !== '';
}

@Component({
  selector: 'app-griglia',
  templateUrl: './griglia.component.html',
  styleUrls: ['./griglia.component.css']
})

export class GrigliaComponent implements OnInit,AfterViewInit {
  //@ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;
  @ViewChild('gridSelection', { static: false }) gridSelection: DxDataGridComponent;
  @Input() colonne:any[] ;
  @Input() dataSource:any;
  @Input() api;
  @Input() service;
  @Input() tipoSelezione='multiple';
  @Input() key='id';
  @Input() remoteOperations=false;
  @Input() filterRequired=false;
  @Input() filterApi='';
  @Input() checkBoxesMode='always'
  @Input() selectAllMode='allMode' 
  @Input() gridHeight?:string;
  @Input() name:string=''
  @Input() titolo='Seleziona'
  @Input() static:boolean=false
  @Input() dxoscrolling: string = "infinite";
  @Input() selectedRowKeys:number[]=[];
  @Output() selezione: EventEmitter<any> = new EventEmitter();
  @Output() outputEmit: EventEmitter<any> = new EventEmitter();
  
  @Input() containerComponent: any; // instanza del padre
  
  ds:CustomStore | [];
  //ds:any;

  customDataSource: CustomStore;
  odataStore: ODataStore;

  componentRef: any;
  
  that:any;
  constructor(
      private httpClient: HttpClient,
      private userComponentService: ComponentService,    
      private appService: Apiservice,
      
      private http: HttpClient,
      private dati: FormsTemplateService, private cdref: ChangeDetectorRef, private componentFactoryResolver: ComponentFactoryResolver,
    ) {
      this.that = this;
      /*if(this.static==false)
        this.ds= this.generateDS();     
      console.log("ecco la key ",this.key)
      */
    }

  ngAfterViewInit(): void {
    

    let elementGrid=null;
    if(this.name){
      let xx=this.name.replace(/[ ]/g,''); // toglie eventuali spazi nel nome
      elementGrid=$("#gridSelection [name="+xx+"]")  
    }
    if(elementGrid){
      $(elementGrid).height(this.gridHeight+"px");  
      $(elementGrid).css('height', this.gridHeight+"px")   
    }
  }

  onSelectionChanged(e){
    console.log("onSelectionChanged ",e.comonent)
    console.log("onSelectionChanged ",e.selectedRowKeys)
    if(e.selectedRowKeys.length>=0)
    this.selezione.next(e.selectedRowKeys)
  }
  onRowClick(e){
    
    console.log("Clikkato su row ",e)
    if(this.tipoSelezione=='single') return;
    const keys = e.component.getSelectedRowKeys();  
    const index = keys.indexOf(e.key);  
    if (index > -1) {  
      keys.splice(index, 1);  
    } else {  
      keys.push(e.key);  
    }  
    e.component.selectRows(keys);  
   // this.selezione.next(keys)
  }
  /*
  generateodataStore(key:string,
    api:string,
    remoteOperations:boolean,
    filterRequired:boolean,
    filterApi:string){

      return {
        store: {
          type: 'odata',
          url: environment.BASE_API_URL + api + filterApi,
          key: key,
          version:4,
          keyType: "Int32",
        },
        //filter: ['Product_Current_Inventory', '>', 0],
      };


      return new ODataStore({
        url: environment.BASE_API_URL + api + filterApi,
        key: key,
        
        onLoaded: () => {
            // Event handling commands go here
        }
    });
    }
  */
  generateDS(api:string,key:string){
    const pippo=this;
    return new CustomStore({
      key: key,      
      useDefaultSearch: true,              
      onLoaded(result) {
        var items = result;
      },
      load(loadOptions: any) {
        let params: HttpParams = new HttpParams();
        [
          'skip',
          'take',
          'requireTotalCount',
          'requireGroupCount',
          'sort',
          'filter',
          'totalSummary',
          'group',
          'groupSummary',
          'TipoOperazione',
          'count'
        ].forEach((option) => {
          if (option in loadOptions && isNotEmpty(loadOptions[option])) {
            console.log("loadOptions[option] ", loadOptions[option])
            //$filter=contains(Location/Address, 'San Francisco')
            if (option == 'filter') {              
              try {
                let a = loadOptions[option][0][1]
                loadOptions[option][0][1] = a.replace('startswith', 'ge')
                //loadOptions[option][0][1]=a.replace('startswith','ge')
                let c = loadOptions[option][0][2]
                c = c.replace(',', '|')
                loadOptions[option][0][2] = c
              } catch (error) {
                let a = loadOptions[option][1]
                loadOptions[option][1] = a.replace('startswith', 'ge')

                let c = loadOptions[option][2]
                try {
                  if (c) c = c.replace(',', '|')
                } catch (error) {
                  //
                }
               
                loadOptions[option][2] = c
              }
            }           
            params = params.set(option, JSON.stringify(loadOptions[option]));
          }
        });
        //params = params.set('count', 'true');
        let myOrder = "$orderby=Descrizione"
        //params = params.set('$orderby', 'Descrizione');
             
        return pippo.dati.getDatiAsync(pippo.api).then(res => {
          let r=res;
          if (res['items']) {
            res = res['items']
          } else {
            res = res
          }
          console.log(res)
          return {
            "data": res,//res,
            "totalCount": r['totalCount']

          };
          return res
        })
      },

    });    
}

  
  generateCustomDataSource(key:string,
    api:string,
    remoteOperations:boolean,
    filterRequired:boolean,
    filterApi:string){
      let httpClient=this.httpClient;
      return new CustomStore({
        key: key,      
        useDefaultSearch: true,
        //paginate: true,
        //pageSize: 10,
                  
        onLoaded(result) {
          var items = result;
        },
        byKey(key) {
          if (key > '')
            return httpClient.get(environment.BASE_API_URL + this.api + "/" + key).toPromise().then(res => {
              if (res['items']) {
                res = res['items']
              } else {
                res = res
              }
              return res
            })
        },
        load(loadOptions: any) {
          let params: HttpParams = new HttpParams();
          [
            'skip',
            'take',
            'requireTotalCount',
            'requireGroupCount',
            'sort',
            'filter',
            'totalSummary',
            'group',
            'groupSummary',
            'TipoOperazione',
            'count'
          ].forEach((option) => {
            if (option in loadOptions && isNotEmpty(loadOptions[option])) {
              console.log("loadOptions[option] ", loadOptions[option])
              //$filter=contains(Location/Address, 'San Francisco')
              if (option == 'filter') {              
                try {
                  let a = loadOptions[option][0][1]
                  loadOptions[option][0][1] = a.replace('startswith', 'ge')
                  //loadOptions[option][0][1]=a.replace('startswith','ge')
                  let c = loadOptions[option][0][2]
                  c = c.replace(',', '|')
                  loadOptions[option][0][2] = c
                } catch (error) {
                  let a = loadOptions[option][1]
                  loadOptions[option][1] = a.replace('startswith', 'ge')
  
                  let c = loadOptions[option][2]
                  try {
                    if (c) c = c.replace(',', '|')
                  } catch (error) {
                    //
                  }
                 
                  loadOptions[option][2] = c
                }
              }           
              params = params.set(option, JSON.stringify(loadOptions[option]));
            }
          });
          //params = params.set('count', 'true');
          let myOrder = "$orderby=Descrizione"
          //params = params.set('$orderby', 'Descrizione');
          
          if(remoteOperations==false)
            params = new HttpParams();
          if (filterRequired && this.filterApi == '') return
          return httpClient.get(environment.BASE_API_URL + api + filterApi, { params }).toPromise().then(res => {
            let r=res;
            if (res['items']) {
              res = res['items']
            } else {
              res = res
            }
            console.log(res)
            return {
              "data": res,//res,
              "totalCount": r['totalCount']

            };
            return res
          })
        },
      });    
  }
  ngOnInit(): void {
    this.that = this;
    console.log("ecco la key in init",this.name)
    if(this.static==false){            
      this.ds=this.generateCustomDataSource(this.key,this.api,this.remoteOperations,
      this.filterRequired,
      this.filterApi)
    }
    else{
        this.ds=this.dati.getDati(this.api)
    }     

  

    //-------------------------------------
    /*this.appService.GetApi(this.api).then(datiGriglia=>{
      var JsonObject = JSON.parse(JSON.stringify(datiGriglia));
      console.log('JsonObject ',JsonObject)
      JsonObject.items.forEach((element, i) => {                           
            this.colonne.push(element)          
      })            
    })*/ 
    

    
  }
  inizializza(data:any){
    this.api=data[0].api;
    this.service=data[0].service;
    this.tipoSelezione=data[0].tipoSelezione
    

  }
  selezionati(){

    this.selezione.emit(this.gridSelection.instance.getSelectedRowsData());
  }
}
